<template>
  <div class="box">
    <div class="box-header with-border">
      <div class="col-xs-12 col-md-6">
        <h3 class="box-title">每日訂單數量</h3><br><br>
        <div class="box-body p-0">
          <div class="col-xs-12">
            <canvas id="amount-chart"></canvas>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <h3 class="box-title">每日訂單金額</h3><br><br>
        <div class="box-body p-0">
          <div class="col-xs-12">
            <canvas id="money-chart"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import Chart from 'chart.js'

  // vuex
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrderLineCharts',
    data () {
      return {
        start_date: moment().subtract(15, 'days').format('YYYY-MM-DD'),
        end_date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        roleType: 0,
        chartData: {
          labels: [],
          amount: [],
          money: []
        },
        amountChart: null, // 訂單數量圖
        moneyChart: null // 訂單金額圖
      }
    },
    computed: {
      ...mapGetters(['getRoleType']),
      getDataH () {
        return this.$parent.getDataH
      }
    },
    created () {
      this.roleType = parseInt(this.getRoleType, 10)
      this.getOrderSummary()
    },
    methods: {
      getOrderSummary () {
        let query = {
          list_type: 'daily',
          start_date: this.start_date.replace(/-/g, ''),
          end_date: this.end_date.replace(/-/g, '')
        }
        const searchParams = new URLSearchParams(query)
        const url = '/statistic/orderSummary?' + searchParams.toString()
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            // 清空訂單總數量 & 訂單總金額
            this.chartData.labels = []
            this.chartData.amount = []
            this.chartData.money = []

            const list = response.data.list
            for (const i in list) {
              this.chartData.labels.push(moment(list[i].date).format('MM/DD'))
              this.chartData.amount.push(list[i].order_amount_accepted)
              this.chartData.money.push(list[i].order_money_accepted)
            }
            this.showOrderChart()
          }
        })
      },
      showOrderChart () {
        this.$nextTick(() => {
          const type = ['amount', 'money']
          type.forEach(item => {
            // clear
            if (this[`${item}Chart`] !== null) {
              this[`${item}Chart`].destroy()
            }
            // set chart
            const ctx = document.getElementById(`${item}-chart`).getContext('2d')
            const config = {
              type: 'line',
              data: {
                labels: this.chartData.labels,
                datasets: [{
                  label: item === 'amount' ? '訂單數量' : '訂單金額',
                  data: this.chartData[item],
                  fill: false,
                  borderColor: '#dd4b39',
                  pointBackgroundColor: '#dd4b39',
                  tension: 0.3
                }]
              },
              options: {
                responsive: true,
                legend: {
                  display: false
                },
                scales: {
                  yAxes: [{
                    display: true,
                    ticks: {
                      min: 0
                    }
                  }]
                }
              }
            }
            this[`${item}Chart`] = new Chart(ctx, config)
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// OrderLineCharts.vue?19ec24f2